import { getCookie } from '@api/HelperAPI';

import { FundingRequirementsPage } from './FundingRequirementsPage/FundingRequirementsPage';
import LegacyFundingRequirementsView from '../../../../funding/fundingRequirementsView/FundingReqirementsView';

export const FundingRequirementsDE = () => {
    const isV2 = getCookie('show_v2_funding_requirements') === 'true';

    if (isV2) {
        return (
            <div data-testid="funding-requirements-page-v2">
                <FundingRequirementsPage />
            </div>
        );
    }

    return (
        <div data-testid="legacy-funding-requirements">
            <LegacyFundingRequirementsView />
        </div>
    );
};
